import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./layout/Navbar";
import { useDispatch } from "react-redux";
// import { isAuthenticated } from "./utils/_helpers";
import usePostRequest from "./hooks/usePostRequest";
import { saveUser } from "./redux/authReducer";
import { API_ENDPOINTS } from "./constant/_constant";
import Header from "./layout/Header";
import Footer from "./layout/Footer";

const pageHeadings = {
  "/aspetto/departments": "Department Management",
  "/aspetto/dashboard": "Aspetto Portal Overview",
  "/aspetto/permissions": "Assign Permissions",
  "/aspetto/users": "User Management",
  "/aspetto/vendor": "Vendor Management",
};

const BaseRoute = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  // const isAuthenticate = isAuthenticated();
  const { postData: getUserDetails } = usePostRequest(
    API_ENDPOINTS.GET_USER_DETAILS
  );

  const onSuccess = (response) => {
    dispatch(saveUser(response));
  };

  useEffect(() => {
    // if (isAuthenticate) {
    getUserDetails({}, onSuccess);
    // }
  }, []);

  // console.log("location", location.pathname);

  return (
    <>
      {/* <Navbar /> */}
      <Header />
      <div
        className={`${["/list-order-lifecycle", "/list-opportunities", "/list-contract-vehicles", "/list-rma"].includes(
          location.pathname
        )
          ? "container-fluid"
          : "container-xl"
          } `}
      >
        <div className="page-wrapper">
          {location.pathname !== "/aspetto/vendor" &&
            location.pathname !== "/aspetto/create-vendor" && (
              <div className="page-header d-print-none">
                <div className="row g-2 align-items-center">
                  <div className="col">
                    <h2 className="page-title">
                      {pageHeadings[location.pathname]}
                    </h2>
                  </div>
                </div>
              </div>
            )}
          <div className="page-body">
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BaseRoute;
